export default window._cmsContent['solar/new-postcode']